/**
 * ORT WebGPU (JSEP) implements `GatherBlockQuantized`; the WASM EP often does not, so q4
 * (`model_q4.*`) fails on WASM with "Could not find an implementation for GatherBlockQuantized".
 * Use q8 (`model_quantized.*`) when running on WASM.
 */
export function preferredOnnxDtypeForBackend(device: 'webgpu' | 'wasm'): 'q4' | 'q8' {
  return device === 'webgpu' ? 'q4' : 'q8';
}

/**
 * The q8 model for some HuggingFace ONNX exports uses GatherBlockQuantized in the embedding
 * layer (mixed 4-bit/8-bit quantization). Android's WASM engine lacks this ORT kernel.
 * Detect the error so the caller can retry with fp16.
 */
export function looksLikeGatherBlockQuantizedError(message: string): boolean {
  return message.includes('GatherBlockQuantized');
}

/**
 * WebGPU on Android often exposes an adapter but fails when creating compute pipelines
 * (e.g. "Failed to create a WebGPU compute pipeline"). Prefer WASM there.
 */
export function shouldAvoidWebGPUInThisEnvironment(): boolean {
  if (typeof navigator === 'undefined') return true;
  return /Android/i.test(navigator.userAgent || '');
}

/** ORT WebGPU / browser errors when GPU path breaks at pipeline compile time */
export function looksLikeWebGpuPipelineFailure(message: string): boolean {
  const m = message.toLowerCase();
  return (
    m.includes('webgpu compute pipeline') ||
    m.includes('webgpu render pipeline') ||
    (m.includes('failed to create') && m.includes('webgpu')) ||
    (m.includes('webgpu') && m.includes('pipeline') && m.includes('failed'))
  );
}
